import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./CardBody.styled";
export const CardBody = forwardRef((props, ref) => {
    const { children, ...otherProps } = props;
    return (_jsx(Styled.CardBody, { "data-testid": "CardBody", ref: ref, ...otherProps, children: children }));
});
CardBody.displayName = "CardBody";
